<template>
  <div class="card">
    <div class="card-title">{{ title }}</div>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: ['title']
};
</script>

<style lang="scss">
.card {
  display: flex;
  flex-direction: column;
  // min-height: 100vh;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
  @include light-shadow;

  .card-title {
    text-align: center;
    font-weight: 500;
    background-color: $gray-light;
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
    margin-bottom: 0.5rem;
    min-height: 2.5rem;
    font-weight: bold;
  }
}
</style>
